import styled from 'styled-components';

export const Photo = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${({ bgColor }) => bgColor};
  background-image: url(${({ image }) => image});
  background-size: ${({ placeholder }) => (placeholder ? '40%' : 'cover')};
  background-repeat: no-repeat;
  background-position: center center;
`;

export const Container = styled.div`
  position: relative;
  width: ${({ itemSize }) => itemSize.width};
  height: ${({ itemSize }) => itemSize.height};
  background-color: ${({ bgColor }) => bgColor};
  display: block;
  flex-shrink: 0;
  margin: 0 12px;
  overflow: hidden;
  cursor: pointer;

  &:hover {
    ${Photo} {
      transform: scale(1.05);
      transition: all 0.1s ease-in;
    }
  }
`;

export const Description = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  color: #fff;
  padding: 24px;
  box-sizing: border-box;
`;

export const Title = styled.h2`
  line-height: 22px;
  margin: 0 0 12px 0;
`;
